import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import areaSelect from '@/components/cascader.vue';
import { policyDetail, claimsVerifyy } from './../request';
import { claimsTypeResource } from './../../../claim/typeManage/request';
import { claimsItemTypeResource } from './../../../claim/productManage/request';
import { claimsTypeName } from './../../../claim/typeManage/request';
import eventBus from '@/utils/eventBus';
import { claimsTempConfig } from './../../homeManage/request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  components: {
    topTitle,
    areaSelect
  },
  props: {
    infoObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      policyInfo: {},
      typeId: undefined,
      typeList: [],
      list: [],
      description: ''
    };
  },
  created() {
    policyDetail({
      policyId: this.$route.params.id
    }).then(res => {
      console.log(res);
      this.policyInfo = res.policyInfo;
      claimsTypeResource({
        insuranceId: res.policyInfo.insuranceId
      }).then(res2 => {
        this.typeList = res2;
      });
    });
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    async onSubmit() {
      const submitData = recursionCopy(this.list);
      submitData.map(item => {
        item.claimsParam.map(item2 => {
          delete item2.selectarr;
          item2.paramPlaceholder = item2.paramPlaceholder || '';
          item2.auditOpinion = '';
          return item2;
        });
        return item;
      });
      const res = await claimsVerifyy({
        policyId: this.$route.params.id,
        claimsTypeId: this.typeId,
        claimsContent: JSON.stringify(submitData)
      });
      this.list = res.claimsContent.map((item, index) => {
        item.claimsParam.map((item2, index2) => {
          let obj = item2;
          if (item2.paramType == 'dropDownBox' || item2.paramType == 'profession' || item2.paramType == 'dropDownBox(region.code)') {
            obj.paramPlaceholder = item2.paramPlaceholder || undefined;
            obj.selectarr = this.list[index].claimsParam[index2].selectarr;
          }
          obj.auditOpinion = this.$t('请填写') + this.$t(item2.paramName);
          return obj;
        });
        return item;
      });
      if (!res.isError) {
        this.infoData.claimsSort = this.list.map(item => {
          item.claimsParam.map(item2 => {
            item2.auditOpinion = '';
            return item2;
          });
          return item;
        });
        eventBus.$emit('policyClaimInfo', this.infoData);
        this.$emit('next');
      }
    },
    async typeChange() {
      console.log(this.typeId);
      this.list = [];
      const res = await claimsItemTypeResource({
        insuranceId: this.policyInfo.insuranceId,
        claimsTypeId: this.typeId
      });
      this.infoData = res;
      this.list = res.claimsSort.map(item => {
        item.claimsParam.map(async item2 => {
          if (item2.paramType == 'dropDownBox' || item2.paramType == 'profession' || item2.paramType == 'dropDownBox(region.code)') {
            item2.selectarr = [];
            item2.paramPlaceholder = item2.paramPlaceholder ? item2.paramPlaceholder : undefined;
            item2.selectarr = await claimsTempConfig({
              tempCode: item2.paramCode
            });
            console.log(item2.selectarr);
          }
          return item2;
        });
        return item;
      });
      console.log(this.list);
      const res2 = await claimsTypeName({
        claimsTypeId: this.typeId
      });
      this.description = res2.description;
    },
    selectArea(value, valueName, index, index2) {
      this.list[index].claimsParam[index2].paramPlaceholder = valueName;
      this.list[index].claimsParam[index2].selectarr = value;
    }
  }
};